module.exports = __webpack_public_path__ + "static/media/indorse-logo@2x.9e4d6eb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/brand/indorse-logo@2x.png
// module id = 561
// module chunks = 146